import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 1.5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m-.75-9.22V6.56a.75.75 0 0 1 1.5 0v4.22a.75.75 0 0 1-1.5 0m.75 1.65a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }